import { render, staticRenderFns } from "./TooltipSelectorAntV.vue?vue&type=template&id=96be5abc&scoped=true"
import script from "./TooltipSelectorAntV.vue?vue&type=script&lang=js"
export * from "./TooltipSelectorAntV.vue?vue&type=script&lang=js"
import style0 from "./TooltipSelectorAntV.vue?vue&type=style&index=0&id=96be5abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96be5abc",
  null
  
)

export default component.exports